import { createAction } from 'redux-actions';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
import getGuid from 'ui-forms-editor-automation-lib/selectors/getGuid';
import getFlows from 'ui-forms-editor-automation-lib/api/getFlows';
import SOURCE_APP from 'ui-forms-editor-automation-lib/constants/SOURCE_APP';
import createErrorAction from 'ui-forms-editor-automation-lib/utils/createErrorAction';
import getFlowsRequestState from 'ui-forms-editor-automation-lib/selectors/flows/getFlowsRequestState';
import getFlowsGuid from 'ui-forms-editor-automation-lib/selectors/flows/getFlowsGuid';
import getFlowUsages from 'ui-forms-editor-automation-lib/selectors/flowUsages/getFlowUsages';
import getFlowUsagesRequestState from 'ui-forms-editor-automation-lib/selectors/flowUsages/getFlowUsagesRequestState';
export const REQUEST_FLOWS = '@@lib/REQUEST_FLOWS';
export const RECEIVE_FLOWS = '@@lib/RECEIVE_FLOWS';
export const FAIL_GETTING_FLOWS = '@@lib/FAIL_GETTING_FLOWS';
export const requestFlows = createAction(REQUEST_FLOWS);
export const receiveFlows = createAction(RECEIVE_FLOWS);
export const failGettingFlows = createAction(FAIL_GETTING_FLOWS);
export const failGettingFlowsWithError = createErrorAction(FAIL_GETTING_FLOWS, 'automationLib.errorMessages.failReceivingWorkflows');
const fetchFlows = (providedGuid, providedSourceApp) => (dispatch, getState) => {
  const state = getState();
  const flowsRequestState = getFlowsRequestState(state);
  const flowUsagesRequestState = getFlowUsagesRequestState(state);
  const guid = providedGuid || getGuid(state);
  const flowUsages = getFlowUsages(state);
  const flowIds = flowUsages.map(usage => usage.id);
  if (!flowsRequestState.shouldBeRequested() && getFlowsGuid(state) === guid) {
    return Promise.resolve();
  }

  // if the flow usages are complete and there are no flow usages, return an empty array - otherwise the request will return all flows for the portal
  if (flowUsagesRequestState.isComplete() && flowUsages.length === 0) {
    return dispatch(receiveFlows({
      results: []
    }));
  }
  let sourceApp = providedSourceApp;
  if (!sourceApp) {
    const applicationName = getApplicationName(state);
    switch (applicationName) {
      case APPLICATION_NAMES.LEADFLOWSUI:
        sourceApp = SOURCE_APP.LEAD_FLOWS_APP;
        break;
      case APPLICATION_NAMES.FORMSUI:
      default:
        sourceApp = SOURCE_APP.FORMS_APP;
        break;
    }
  }
  dispatch(requestFlows(guid));
  return getFlows(flowIds, sourceApp).then(flows => {
    dispatch(receiveFlows(flows));
  }).catch(error => {
    switch (error.status) {
      case 403:
        dispatch(failGettingFlows(error));
        break;
      default:
        dispatch(failGettingFlowsWithError(error));
        break;
    }
  });
};
export default fetchFlows;